import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );

  // Send the agent's UI language with every request so server-side strings
  // (e.g. activity messages like "Conversation was marked resolved by") are
  // generated in the agent's own language instead of the account locale.
  // The agent's language is stored per-user in localStorage (gamefireHelper),
  // read fresh on each request so live language changes take effect immediately.
  wootApi.interceptors.request.use(config => {
    const authData = Auth.hasAuthCookie() ? Auth.getAuthData() : {};
    const agentEmail = authData.uid;
    if (agentEmail) {
      const agentLocale = localStorage.getItem(`locale-${agentEmail}`);
      if (agentLocale) {
        config.params = { ...(config.params || {}), locale: agentLocale };
      }
    }
    return config;
  });

  return wootApi;
};
